import ApiActions from './Api/actions'

const actions = Object.assign(
    ApiActions
);
export default actions;
